module.exports = require('./helpers/bundle-url').getBundleURL('hX3nb') + "logo.c51670a8.svg";